import { createReducer } from "typesafe-actions";
import { JWTToken } from "../../../oauth";
import { authAsync, logoutAsync } from "./sagas";

export interface AuthReducerState {
  token: JWTToken;
  loading: boolean;
}

const initalState: AuthReducerState = {
  loading: false,
  token: new JWTToken(localStorage.getItem("token")),
};

export const authReducer = createReducer<AuthReducerState>({
  ...initalState,
})
  .handleAction(
    authAsync,
    (state: AuthReducerState, action: any): AuthReducerState => {
      return {
        token: new JWTToken(action.payload),
        loading: true,
      };
    }
  )
  .handleAction(
    logoutAsync,
    (state: AuthReducerState, action: any): AuthReducerState => {
      localStorage.removeItem("token");
      return {
        ...state,
        token: new JWTToken(null),
      };
    }
  );
